module.exports = __webpack_public_path__ + "472ec016d50155cad6cce087327eff9e.svg";